module.exports = __webpack_public_path__ + "img/calender.06ff071b.png";